export default {"src":"https://frontends.udemycdn.com/frontends-marketplace-experience/_next/static/media/design.4a134af9.svg","height":24,"width":24};